import { Injectable } from "@angular/core";
import { FormGroup, ValidationErrors } from "@angular/forms";
import { AsyncValidator, registerAsyncValidatorDecorator } from "@recursyve/ngx-form-generator";
import { Observable } from "rxjs";

export function RequireForOneLanguage(): PropertyDecorator {
    return registerAsyncValidatorDecorator({
        name: "RequireForOneLanguage"
    });
}

@Injectable()
export class RequireForOneLanguageValidator extends AsyncValidator {
    public readonly name = "RequireForOneLanguage";

    public validate(formGroup: FormGroup): Observable<ValidationErrors | null> {
        const requiredLanguages = ["fr", "en"];
        const hasAtLeastOneLanguage = requiredLanguages.some((language) => {
            const control = formGroup.get(language);
            return typeof control?.value === "string" && control.value.trim().length > 0;
        });

        if (!hasAtLeastOneLanguage) {
            return new Observable<ValidationErrors | null>((observer) => {
                observer.next({
                    languageRequired: {
                        missingLanguages: requiredLanguages
                    }
                });
                observer.complete();
            });
        }

        return new Observable<ValidationErrors | null>((observer) => {
            observer.next(null);
            observer.complete();
        });
    }
}
